import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { LeaderboardScoreFragment } from 'api';

import LeaderboardTableRow from './TableRow';

interface IProps {
  items: LeaderboardScoreFragment[];
}

const useStyles = makeStyles(theme => ({
  firstCell: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  lastCell: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(3),
  },
}));

const LeaderboardTable: FC<IProps> = ({ items }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" className={classes.firstCell}>
              {t('common:rank')}
            </TableCell>
            <TableCell align="center" className={classes.firstCell}>
              {t('common:change')}
            </TableCell>
            <TableCell className={classes.firstCell} />
            <TableCell>{t('common:name')}</TableCell>
            <TableCell>{t('common:title')}</TableCell>
            <TableCell>{t('common:point_plural')}</TableCell>
            <TableCell className={classes.lastCell} />
          </TableRow>
        </TableHead>
        <TableBody>
          {!items.length && (
            <TableRow>
              <TableCell colSpan={7}>
                <em>{t('components:noLeaderboardResults')}</em>
              </TableCell>
            </TableRow>
          )}
          {items.map(item => (
            <LeaderboardTableRow key={item.user_id} row={item} />
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default LeaderboardTable;
